import Landingsidebar from "../../Components/sidebar/landingsidebar";
import React, { useState } from "react";
import PlusWhite from "../../assets/images/plus_white.svg";
import brandlogo from "../../assets/images/brand_logo.svg";
// import { useNavigate } from "react-router-dom";
import ToggleExpandIcon from "../../assets/images/toggleExpand_icon.svg";
import Hidelogo from '../../assets/images/glenzyLogo_short.svg'

import { Outlet, useNavigate } from "react-router-dom";
import UserAvatar from "../../Components/UserAvatar/UserAvatar";
// import Header from "../../Components/Header";

export const TenantLanding = () => {
  const [webToggle, setWebToggle] = useState(false);

  const handleWebToggle = () => {
    setWebToggle((prev) => !prev);
  };
  // // const navigate = useNavigate();
  // let tenant = sessionStorage.getItem("tenantId");
  // let SubscriptionId = sessionStorage.getItem("subscriptionId");
  // let subs_token = sessionStorage.getItem("tenantToken")


  // const gotoSubscription = () => {
  //   navigate(`/tenant-dashboard/${tenant}`);
  // };
  // const gotoBusiness = () => {
  //   navigate(`/businessinfo/${tenant}`);
  // };
  // const gotoProfile = () => {
  //   navigate(`/profile/${tenant}`);
  // };
  // const gotoChangePassword = () => {
  //   navigate("/change-password");
  // };
  // const gotoConfig = () => {
  //   if (SubscriptionId === null) {
  //     SubscriptionId = sessionStorage.getItem("subscriptionId");
  //   }
  //   console.log("Landing subscription ID::", SubscriptionId);
  //   navigate(`/control-panel/dashboard/${SubscriptionId}/${subs_token}`);
  // };
  const navigate = useNavigate();

  const handleNewSubscription = () => {
    sessionStorage.removeItem("ProductId");
    sessionStorage.removeItem("selectedthemeid");
    sessionStorage.removeItem("VerticalId");
    sessionStorage.removeItem("tenantID");
    sessionStorage.removeItem("themeId");
    sessionStorage.removeItem("subscriptionId");
    sessionStorage.removeItem("selectedVertical");
    sessionStorage.removeItem("businessName");
    sessionStorage.setItem("newSubscription", true);
    navigate("/vertical");
  };


  return (
    <>
      {/* <div className="logoutblock">


        <div className="logosection">
          <div className="displayFlex">
            <img src={menuicon} className="mobileMenuicon" />
            <div className="brand_logo">
              <img src={logo} className="whiteFilter" />
            </div>
          </div>
        </div>


        <ul class="user_admin">
          <li>
            <button
              className="MainButton aareRiverBrienz_Clr"
              target="_blank"

            >
              <Dropdown>
                <Dropdown.Toggle id="dropdown-basic">
                  settings
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={gotoSubscription}>
                    My Subscription
                  </Dropdown.Item>
                  <Dropdown.Item onClick={gotoBusiness}>
                    My Business
                  </Dropdown.Item>
                  <Dropdown.Item onClick={gotoProfile}>
                    My Profile
                  </Dropdown.Item>
                  <Dropdown.Item onClick={gotoChangePassword}>
                    Change Password
                  </Dropdown.Item>
                  <Dropdown.Item onClick={gotoConfig}>
                      Configuration
                     </Dropdown.Item>
                            
                </Dropdown.Menu>
              </Dropdown>
            </button>
          </li>





        </ul>

            </div> */}


      <div className={!webToggle ? "page_wrapper" : " page_wrapper show"}>

        <Landingsidebar webToggle={webToggle} />
        <div className="content_wrapper">
          <div className="quickGuide_header">
            {/* {window.location.pathname !== "/docs/home" && ( */}
            <div className="displayFlex  Alignitem_center gap_12">
            <div className="mobileLogo">
              <img src={Hidelogo} alt="Hidelogo"/>
            </div>
            <div>
              <button className="emptyBtn" onClick={handleWebToggle}>
                <img src={ToggleExpandIcon} alt="ToggleExpandIcon" />
              </button>
            </div>
            </div>
            <div className="displayFlex userProfileicon">
              <div className="mr_20" onClick={handleNewSubscription}>
                <button className="Mainbutton">
                  <img width={20} height={20} src={PlusWhite} alt="add" />
                  <span> Add Subscription</span>
                </button>
              </div>
              {/* user avatar */}
              <UserAvatar
                business={true}
                profile={true}
                changePassword={true}
                quickGuide={true}
                logout={true}
              />
            </div>
          </div>
          <div className="contentFrame">
            <Outlet />
          </div>
        </div>


      </div>
    </>
  );
};
